import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
export function Home() {
  return <main id="home" className="w-full" data-id="element-289" data-mp="2nfcyxjqjq72x">
      <HomeHero data-id="element-290" data-mp="2nebpfjp6hsnb" />
    </main>;
}